module.exports = __webpack_public_path__ + "static/media/logo.acd8dcfc.png";